import { action } from 'mobx'
import { useLocalObservable } from 'mobx-react'
import type { DependencyList } from 'react'
import { useEffect } from 'react'

/**
 * @param scrollbarsSelector 스크롤바가 있는 요소를 선택하는 선택자
 * * 예시: '.table-scroll-body > div:first-of-type'
 * @param options 스크롤바 이벤트 핸들러
 * @param deps 의존성 배열
 */
const useScrollbars = (
  scrollbarsSelector = '.table-scroll-body > div:first-of-type',
  options?: { onScroll?: (e: Event) => void },
  deps?: DependencyList,
) => {
  const store = useLocalObservable(() => ({
    el: document.querySelector(scrollbarsSelector) as HTMLElement,
    scrollTo(scrollTo: ScrollToOptions) {
      if (store.el) store.el.scrollTo(scrollTo)
    },
    scrollSmoothTo(scrollTo: Pick<ScrollToOptions, 'top' | 'left'>) {
      store.scrollTo({ ...scrollTo, behavior: 'smooth' })
    },
    scrollToTop() {
      store.scrollTo({ top: 0 })
    },
  }))

  useEffect(() => {
    action(() => {
      store.el = document.querySelector(scrollbarsSelector) as HTMLElement
    })

    if (store.el && options?.onScroll) {
      store.el.addEventListener('scroll', options.onScroll)
    }
    return () => {
      if (store.el && options?.onScroll) {
        store.el.removeEventListener('scroll', options.onScroll)
      }
    }
  }, deps ?? [])

  return store
}

export default useScrollbars
